export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BaseTextarea.vue?vue&type=template&id=8a7bb140&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/lk/form/BaseTextarea.vue?vue&type=template&id=8a7bb140&
// module id = 1737
// module chunks = 0